import { configure } from '@js-boot/react-i18n';
import deLang from './locales/de';
import enLang from './locales/en';
import { missingKeyHandler } from './utils';
import { isFeatureFlagEnabled } from '@/utils/isFeatureFlagEnabled.util';
import { adacTranslations } from '@/components/content/benefits/modals/adac/translations';

// Feature flag keys
const FEATURE_FLAG_KEY = 'use_i18n';

const i18nInstance = configure({
  defaultNS: 'common',
  resources: {
    de: {
      common: deLang,
      adac: adacTranslations.de,
    },
    en: {
      common: enLang,
      adac: adacTranslations.en,
    },
  },
  overrides: {
    saveMissing: true,
    missingKeyHandler,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    react: {
      transSupportBasicHtmlNodes: true,
    },
  },
});

const languageSetting = isFeatureFlagEnabled(FEATURE_FLAG_KEY) ? i18nInstance.language : 'de';

i18nInstance.changeLanguage(languageSetting);

export default i18nInstance;
